import EventBus from 'eventing-bus';
import { toast } from 'react-toastify';
import Box from '@material-ui/core/Box';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import TextField from '@mui/material/TextField';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

const optionsSelectPermissions = [
    { value: "Dashboard", label: 'Dashboard' },
    { value: "View Campaigns", label: 'View Campaigns' },
    { value: "Unibox", label: 'Unibox' },
    { value: "Analytics", label: 'Analytics' },
    { value: "Blocklist", label: 'Blocklist' },
];

const ValueDomain = 'agency.iteackly.com';
const initialFormState = { oldPassword: '', newPassword: '', confirmNewPassword: '' }

const Agency = ({ tabOptionsPhone }) => {
    const dispatch = useDispatch();
    const [form, setForm] = useState(initialFormState);
    const [isVisibleMoreOptions, setIsVisibleMoreOptions] = useState(false);

    const handleSubmit = e => {
        e.preventDefault()

        if (form['newPassword'] !== form['confirmNewPassword'])
            return toast.error("New Password must match Confirm Password")
        setIsFetching(true);

        dispatch(changePassword({
            formData: { oldPassword: form['oldPassword'], newPassword: form['newPassword'] },
            successCallback: () => {
                setIsFetching(false);
                setForm(initialFormState);
                toast.success('Password updated.');
            },
            failCallback: () => setIsFetching(false)
        }))
    }

    const handleChange = e => {
        if (!e['target']) return
        setForm(st => ({ ...st, [e['target'] && e['target']['name']]: e['target'] && e['target']['value'] }))
    }

    const handleClick = () => {
        setIsVisibleMoreOptions(!isVisibleMoreOptions)
    }

    const handleFileChange = (event) => {
        if (event.target.files.length > 0)
            setFileName(event.target.files[0].name);
    };

    return (
        <div className='tabs-content'>
            <div className='title-top-block'>
                <div className='left-area'>
                    <h2>Agency</h2>
                </div>
            </div>
            <div className='setting-profile-area style-two'>
                <div className='setting-profile-box'>
                    <ValidatorForm className="validator-form" onSubmit={handleSubmit}>
                        <div className='workspace-box-inner style-two'>
                            <div className='workspace-box'>
                                <div className='title-area'>
                                    <i className='icon fa fa-globe'></i>
                                    <h4>Domain</h4>
                                </div>
                                <div className='row'>
                                    <div className='col-lg-6 col-md-6'>
                                        <div className="group-form">
                                            <TextValidator
                                                className="login-input-fields"
                                                fullWidth
                                                margin="dense"
                                                type="email"
                                                name="fName"
                                                required
                                                placeholder="Enter email address"
                                                variant="outlined"
                                                validators={['required']}
                                                onChange={handleChange}
                                                // value={form.oldPassword}
                                                errorMessages={['email address can not be empty']}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-lg-4'>
                                    </div>
                                    <div className='col-lg-2 col-md-6'>
                                        <div className="group-form">
                                            <button className='btn-style-new'>Save</button>
                                        </div>
                                    </div>
                                    <div className='col-12'>
                                        <div className={isVisibleMoreOptions ? 'setupguide-group active' : 'setupguide-group '}>
                                            <span onClick={handleClick}>
                                                {isVisibleMoreOptions
                                                    ? <p>Hide setup guide <i className='icon'><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 7.5L6 4.5L3 7.5" stroke="#4b5563" stroke-linecap="round" stroke-linejoin="round" /></svg></i></p>
                                                    : <p>Show setup guide <i className='icon'><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 4.5L6 7.5L9 4.5" stroke="#4b5563" stroke-linecap="round" stroke-linejoin="round" /></svg></i></p>
                                                }
                                            </span>
                                        </div>
                                        {isVisibleMoreOptions &&
                                            <div className='more-options'>
                                                <div className='recoard-data'>
                                                    <div className='record-box'>
                                                        <p><b>Record Type:</b> CNAME</p>
                                                    </div>
                                                    <div className='record-box'>
                                                        <p><b>Host:</b> Your subdomain or domain</p>
                                                    </div>
                                                    <div className='record-box'>
                                                        <p><b>Value:</b> {ValueDomain}</p>
                                                        <CopyToClipboard text={ValueDomain} onCopy={() => EventBus.publish('success', 'Address Copied!')}>
                                                            <span className='copy-btn'>
                                                                Copy
                                                            </span>
                                                        </CopyToClipboard>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='workspace-box-inner style-two'>
                            <div className='workspace-box'>
                                <div className='title-area'>
                                    <i className='icon fa fa-user'></i>
                                    <h4>Logo</h4>
                                </div>
                                <div className="group-form">
                                    <p>Add a logo to your workspace</p>
                                    <div>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            style={{ display: "none" }}
                                            id="contained-button-file"
                                            onChange={handleFileChange}
                                        />
                                        <label htmlFor="contained-button-file">
                                            <span component="span">
                                                <i className='icon fa fa-upload'></i>
                                                Upload file
                                            </span>
                                        </label>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className='workspace-box-inner style-two'>
                            <h3>Client Accounts</h3>
                            <div className='workspace-box'>
                                <div className='title-area'>
                                    <i className='icon fa fa-user'></i>
                                    <h4>Add New Client Account</h4>
                                </div>
                                <div className='row'>
                                    <div className='col-lg-6 col-md-6'>
                                        <div className="group-form">
                                            <TextValidator
                                                className="login-input-fields"
                                                fullWidth
                                                margin="dense"
                                                type="email"
                                                name="fName"
                                                required
                                                placeholder="Email client email address"
                                                variant="outlined"
                                                validators={['required']}
                                                onChange={handleChange}
                                                // value={form.oldPassword}
                                                errorMessages={['email address can not be empty']}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-lg-4'>
                                    </div>
                                    <div className='col-lg-2 col-md-6'>
                                        <div className="group-form">
                                            <button className='btn-style-new'>Add</button>
                                        </div>
                                    </div>
                                    <div className='col-12'>
                                        <div className="group-form mt-4">
                                            <Autocomplete
                                                options={optionsSelectPermissions}
                                                getOptionLabel={(optionsSelectPermissions) => optionsSelectPermissions.label}
                                                componentsProps={{ paper: { sx: { width: 230 } } }}
                                                sx={{ minWidth: 200 }}
                                                renderOption={(props, optionsSelectPermissions) => (
                                                    <Box component="li" {...props} sx={{ display: "block", alignItems: "center", gap: 1 }}>
                                                        <Typography style={{ fontSize: '14px' }}>{optionsSelectPermissions.label}</Typography>
                                                        {optionsSelectPermissions.detail}
                                                    </Box>
                                                )}
                                                renderInput={(params) => {
                                                    const selectedOption = optionsSelectPermissions.find((opt) => opt.label === params.inputProps.value);
                                                    return (
                                                        <TextField
                                                            {...params}
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                startAdornment: selectedOption ? (
                                                                    <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                                                                ) : null,
                                                            }}
                                                            placeholder="Select permissions"
                                                            variant="outlined"
                                                        />
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ValidatorForm>
                </div>
            </div>
        </div>

    );
};

export default Agency;